export const useTenantId = () => {
  return {
    tenantId: localStorage.getItem("tenantId"),
    setTenantId: (value: string | number) => {
      localStorage.setItem("tenantId", String(value));
    },
  };
};
